module.exports = __webpack_public_path__ + "img/login_background.584b1475.jpg";